import Player from '@vimeo/player';

export const loadScript = () => {
  return Promise.resolve({ Player });
};
